import { Reducer } from 'redux';
import {
  DELETE_RATE_PLAN,
  GET_RATE_PLAN,
  GET_RATE_PLAN_LIST,
  PATCH_RATE_PLAN_STATUS,
  POST_RATE_PLAN,
  PUT_RATE_PLAN,
  RatePlanActionTypes,
  RatePlanState,
  SAVE_DESK_GROUP_ID,
  SAVE_PRODUCT_ID,
  STORE_ACRISS_CODES,
  STORE_BROKER_RATE_ID,
  STORE_DESK_CODE,
  STORE_DESK_GROUP_ID,
  STORE_PRODUCT_ID,
  STORE_STARTING_DATE
} from '../types/rateplan.types';

const initialState: RatePlanState = {
  ratePlans: [],
  selectedRatePlan: null,
  postSuccess: null,
  lastFetch: null,
  productId: null,
  deskGroupId: null,
  acrissCodes: [],
  brokerRateCode: null,
  deskCode: null,
  startingDate: null
};

export const ratePlanReducer: Reducer<RatePlanState> = (
  state: RatePlanState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as RatePlanActionTypes).type) {
    case GET_RATE_PLAN_LIST:
      return {
        ...state,
        ratePlans: action.payload.page.content,
        postSuccess: null,
        lastFetch: timeOfAction
      };
    case GET_RATE_PLAN:
      return {
        ...state,
        postSuccess: null,
        selectedRatePlan: action.payload.selectedRatePlan,
        lastFetch: timeOfAction
      };
    case POST_RATE_PLAN:
      return {
        ...state,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case PUT_RATE_PLAN:
      return {
        ...state,
        selectedRatePlan: action.payload.selectedRatePlan,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_RATE_PLAN:
      return {
        ...state,
        selectedRatePlan: null,
        lastFetch: timeOfAction
      };
    case PATCH_RATE_PLAN_STATUS:
      return {
        ...state,
        selectedRatePlan: action.payload.selectedRatePlan,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case STORE_PRODUCT_ID:
      return {
        ...state,
        productId: action.payload.productId
      };
    case STORE_DESK_GROUP_ID:
      return {
        ...state,
        deskGroupId: action.payload.deskGroupId
      };
    case SAVE_PRODUCT_ID:
      return {
        ...state,
        productId: action.payload.productId
      };
    case SAVE_DESK_GROUP_ID:
      return {
        ...state,
        deskGroupId: action.payload.deskGroupId
      };
    case STORE_DESK_CODE:
      return {
        ...state,
        deskCode: action.payload.deskCode
      };
    case STORE_BROKER_RATE_ID:
      return {
        ...state,
        brokerRateCode: action.payload.brokerRateCode
      };
    case STORE_STARTING_DATE:
      return {
        ...state,
        startingDate: action.payload.startingDate
      };
    case STORE_ACRISS_CODES:
      return {
        ...state,
        acrissCodes: action.payload.acrissCodes
      };
    default:
      return state;
  }
};
